/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_RedirectingInputs */

const zh_subscription_redirecting = /** @type {(inputs: Subscription_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳转中...`)
};

const en_subscription_redirecting = /** @type {(inputs: Subscription_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting...`)
};

const es_subscription_redirecting = /** @type {(inputs: Subscription_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirigiendo...`)
};

/**
* | output |
* | --- |
* | "Redirecting..." |
*
* @param {Subscription_RedirectingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_redirecting = /** @type {((inputs?: Subscription_RedirectingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_RedirectingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_redirecting(inputs)
	if (locale === "en") return en_subscription_redirecting(inputs)
	return es_subscription_redirecting(inputs)
});